export const SET_USERNAME = 'SET_USERNAME';
export const SET_ACCOUNT_LOCKED = 'SET_ACCOUNTLOCKED';
export const SET_PASSWORD_CHANGE_REQUIRED = 'SET_PASSWORD_CHANGE_REQUIRED';
export const SET_LOGIN = 'SET_LOGIN';
export const SET_VICTIM_LOGIN = 'SET_VICTIM_LOGIN';
export const RESET_LOGIN = 'RESET_LOGIN';